import React from 'react';
import { CheckboxInput } from '../../input';
import { Field } from 'react-jeff';

interface Props {
  isFibreSwap: boolean;
  isChangingProviderField :Field<string,string>
  hasBroadBand?: boolean;
}

const ChangingProvider = ({ isFibreSwap, isChangingProviderField, hasBroadBand = false }: Props) => {
  const isFibreSwapFromExternal = isFibreSwap && !hasBroadBand;
  if (!isFibreSwapFromExternal) return null;
const onChange=(value:boolean)=>{
  isChangingProviderField.setValue(String(value));
}
  return (
    <div className="pb-4 w-full">
      <div className="p-8 bg-neutral-off-white">
        <label className="block mb-3 sky-h7-black text-primary-mid-night-blue">{'Changing provider'}</label>
        <p className="text-body-xs">
          {
            'We make it really easy to switch your Broadband to Sky by taking care of the service transfer from your current provider, and you can track the progress of your order on our handy order tracker in My Account. However, there may be an overlap in billing with your current provider so we ask that you check with them to see if they have a *notice period *for the cancellation of services.'
          }
        </p>
        {isFibreSwapFromExternal && (
          <>
            <div className="mt-3 flex">
              <div className='w-7'>
                <CheckboxInput
                  style={isChangingProviderField.errors.length>0 ? { borderColor: "rgb(221 66 60)"} : undefined}
                  {...isChangingProviderField.props}
                  onChange={onChange}
                  checked={isChangingProviderField.value==="true"}
                />
              </div>
              <p className="text-body-xs flex items-center ml-3">
                {'Yes I acknowledge the potential overlap of services & am advised to check with my current provider.'}
              </p>
            </div>
            {isChangingProviderField.errors.length>0 && <p className='text-error'>Please acknowledge the potential overlap of services</p>}
          </>
        )}
      </div>
    </div>
  );
};

export { ChangingProvider };
